// src/routes/index.tsx
import React, { Suspense, lazy } from "react";
import { Routes, Route, Navigate } from "react-router-dom"; // ✅ Supprimer BrowserRouter

import LoadingScreen from "../shared/ui/loading/LoadingScreen";
import { AuthGuard } from "../core/auth/guards/AuthGuard";
import DashboardLayout from "../shared/layouts/dashboard/DashboardLayout";
import { AuthCallback } from "../core/auth/callback/AuthCallback";

// =========================
// Lazy Pages
// =========================
const DashboardPage = lazy(() => import("../features/dashboard/pages/DashboardPage"));
const ProfilePage = lazy(() => import("../features/profile/pages/ProfilePage"));
const SecurityPage = lazy(() => import("../features/security/pages/SecurityPage"));
const IdentityPage = lazy(() => import("../features/identity/pages/IdentityPage"));
const PreferencesPage = lazy(() => import("../features/preferences/pages/PreferencesPage"));
const ApplicationsPage = lazy(() => import("../features/applications/pages/ApplicationsPage"));
const AboutPage = lazy(() => import("../features/about/pages/AboutPage"));
const HelpPage = lazy(() => import("../features/help/pages/HelpPage"));
const NotFoundPage = lazy(() => import("../shared/ui/pages/NotFoundPage"));

// =========================
// Router
// =========================
const AppRouter = () => {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route path="/auth/callback" element={<AuthCallback />} />
      </Routes>
      <AuthGuard>
        <DashboardLayout>
          <Routes>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="security" element={<SecurityPage />} />
            <Route path="identity" element={<IdentityPage />} />
            <Route path="preferences" element={<PreferencesPage />} />
            <Route path="applications" element={<ApplicationsPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="help" element={<HelpPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </DashboardLayout>
      </AuthGuard>
    </Suspense>
  );
};

export default AppRouter;